
import { ElForm } from 'element-ui/types/form'
import { pick } from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'
import { AppModule } from '@/store/modules/app'

const checkStatus = {
    pass: { value: 1, name: '已通过' },
    not: { value: 2, name: '待审核' },
    reject: { value: 3, name: '未通过' }
}

@Component({
    name: 'company-create-form'
})
export default class CompanyDetailForm extends Vue {
    private companyForm = {
        company_type_id: '',
        name: '',
        short_name: '',
        stock_code: '',
        logo: '',
        phone: '',
        email: '',
        official_url: '',
        address: '',
        intro: '',
        industry_ids: '',
        cm_name: '',
        sec_name: '',
        check: checkStatus.not.value,
        products: [{                
            key: +new Date(),
            name: '',               
            url: ''                 
        }]
    }
    private classOptions = []
    private checkStatus = Object.values(checkStatus)
    private companyFormRules = {
        name: [
            { required: true, message: '请输入机构名称' }
        ],
        short_name: [
            { required: true, message: '请输入机构简称' }
        ],
        email: [
            { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ]
    }
    get industryList() {
        return AppModule.industry
    }
    get isShowDeleteButton() {
        return this.companyForm.products.length > 1
    }

    private created() {
        this.getClassList()
    }

    // 企业分类
    private async getClassList() {
        const result = await EnterpriseService.getClassList()
        if (result.status === 200) {
            this.classOptions = result.data
        }
    }

    private onDeleteProduct(product: any) {
        const products = this.companyForm.products as any[]
        const idx = products.indexOf(product)
        products.splice(idx, 1)
    }

    private addProduct() {
        (this.companyForm.products as any).push({
            key: +new Date(),
            name: '',
            url: ''
        })
    }

    private validate(fn: Function) {
        (this.$refs.companyformRef as ElForm).validate((isValid: boolean) => {
            if (!isValid) return
            const industry = Array.isArray(this.companyForm['industry_ids']) 
                ? this.companyForm['industry_ids'].map(n => n.pop())
                : []
            let form = { 
                ...this.companyForm, 
                industry_ids: industry,
                products: this.companyForm['products']
                    .filter(p => p.name && p.url)
                    .map(p => pick(p, ['name', 'url']))
            }
            fn && fn(form)
        })
    }
}
